export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      isShownDialog: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.isShownDialog = val;
      },
    },
    isShownDialog: {
      handler(val) {
        this.$nextTick(() => {
          this.$emit('input', val);
        });
      },
    },
  },
  methods: {
    handleClose() {
      this.isShownDialog = false;
    },
  },
};
